<button
  type="button"
  class="basic-button"
  [ngClass]="[size, type, rounded ? 'rounded' : '', isIcon ? 'is-icon' : '', focusVisible ? 'focus-visible-active' : '']"
  [style.font-size]="fontSize"
  [disabled]="disabled"
  (click)="onClick($event)"
>
  <!-- Text via input property or projected content -->
  <span class="button-text" *ngIf="text">{{ text }}</span>
  <span class="button-content" *ngIf="!text">
    <ng-content></ng-content>
  </span>
</button>

